// src/components/SearchBar.js
import React from "react";
import "../styles/SearchBar.css";

const SearchBar = ({ searchTerm, setSearchTerm, placeholder }) => {
  return (
    <div className="search-container">
      <input
        type="text"
        placeholder={placeholder} 
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        className="search-input"
      />
    </div>
  );
};


export default SearchBar;
